<template>
  <div class="image-wrap">
    <div class="image-header">
      <template v-if="image">
        <div class="image-header-left">
          <v-btn icon small class="back-btn" @click="backToRace">
            <v-icon size="18">$vuetify.icons.chevron-left</v-icon>
          </v-btn>
          {{ image.race_event }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on" @click="copyURL">
                <v-icon size="20">$vuetify.icons.link</v-icon>
              </v-btn>
            </template>
            <span>Copy URL</span>
          </v-tooltip>
          <div class="image-navigation">
            <v-btn icon small @click="goImage('prev')">
              <v-icon size="24">$vuetify.icons.chevron-left-filled</v-icon>
            </v-btn>
            <v-btn icon small @click="goImage('next')">
              <v-icon size="24">$vuetify.icons.chevron-right-filled</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="divider" />
        <ul class="image-tags">
          <li class="image-tags-item">{{ image.session }}</li>
          <li class="image-tags-item">{{ image.track_sector }}</li>
          <li class="image-tags-item">{{ date }}</li>
          <li class="image-tags-item">{{ image.image_width }}x{{ image.image_height }}</li>
        </ul>
        <image-info
          :paramImageId="imageId"
          :raceId="image.race_id"
          :selectedCar="selectedCar"
          :tags="imageTags"
          @selectCar="changeSelectedCar"
          @update="init"
        />
      </template>
      <loader v-else size="24" />
    </div>
    <div class="image-content">
      <ImageToolBar
        @changeOption="changeOption"
        :actions="actions"
        :imageFilters="imageFilters"
        :options="options"
      >
        <v-switch v-model="isDrawBoxes" class="switch-boxes" dense hide-details inset label="B-box" :ripple="false" />
        <CommentDialog
          :visible="isShowCommentModal"
          :value="comment"
          @close="commentDialogCloseHandler"
          @submit="submitCommentHandler"
        />
      </ImageToolBar>
      <ImageCanvas
        v-if="image"
        :images="[image]"
        :cars="image.tags"
        :savedLines="image.lines"
        :isDrawBoxes="isDrawBoxes"
        :selectedCar="selectedCar"
        :options="options"
        :asideWidth="0"
        @selectCar="changeSelectedCar"
        @changeMode="changeOption"
        @saveImage="saveImage"
        ref="imgCanvas"
      />
    </div>
  </div>
</template>

<script>
import { defaultImageFilters } from '@/constants'
import utils from '@/utils/utils'
import ImageCanvas from '../../components/ImageCanvas'
import ImageInfo from "./imageInfo"
import ImageToolBar from '../../components/imageToolBar'
import { getImage, postImageLines, getImagePreviousNext } from '../../api/images'
import { postFeedback } from '../../api/feedback'
import CommentDialog from '../../components/dialogs/CommentDialog'
import Loader from '@/components/Loader'
import { putFavoritesRaceImages } from "../../api/raceimages"
import { mapActions } from 'vuex'

export default {
  name: 'ImagePage',
  components: {
    ImageCanvas,
    CommentDialog,
    ImageInfo,
    ImageToolBar,
    Loader,
  },
  props: {
    paramImageId: {
      type: String
    }
  },
  data() {
    return {
      baseAPIURL: process.env.VUE_APP_BASE_API_URL,
      image: null,
      comment: '',
      isShowCommentModal: false,
      selectedCar: {},
      isDrawBoxes: false,
      options: {
        mode: 'moving',
        lineWidth: 5,
        lineColor: 'red',
        sketchType: 'pencil'
      },
      routeFrom: null,
    }
  },
  computed: {
    actions() {
      return [
        {
          icon: '$vuetify.icons.undo',
          handler: this.undoLine,
          tooltip: 'Undo',
        },
        {
          disabled: !this.image?.favorite,
          icon: '$vuetify.icons.message',
          handler: this.openCommentDialog,
          tooltip: 'Comment',
        },
        {
          icon: '$vuetify.icons.download',
          handler: () => {
            utils.downloadFile(`${this.baseAPIURL}download/images/${this.image._id}`, { target: '_blank' })
          },
          tooltip: 'Download',
        },
        {
          icon: '$vuetify.icons.report',
          handler: this.feedback,
          tooltip: 'Report',
        },
      ]
    },
    imageId() {
      console.log(this.paramImageId);
      return this.$route.params.imageId || this.paramImageId
    },
    date() {
      const date = new Date(this.image.created_date)
      const month = `${date.getUTCMonth()+1}`.padStart(2, '0')
      const day = `${date.getUTCDate()}`.padStart(2, '0')
      const hours = `${date.getUTCHours()}`.padStart(2, '0')
      const minutes = `${date.getUTCMinutes()}`.padStart(2, '0')
      return `${date.getUTCFullYear()}-${month}-${day}, ${hours}:${minutes}`
    },
    imageFilters() {
      return [
        {
          handler: v => this.changeImageFilters('contrast', v),
          icon: '$vuetify.icons.contrast',
          label: 'Contrast',
          value: this.image?.filters?.contrast || '',
        },
        {
          handler: v => this.changeImageFilters('brightness', v),
          icon: '$vuetify.icons.contrast',
          label: 'Brightness',
          value: this.image?.filters?.brightness || '',
        },
      ]
    },
    imageTags() {
      return this.image.tags.map(el => ({
        ...el,
        track_sector: this.image?.track_sector || null,
      }))
    },
  },
  methods: {
    ...mapActions ({
      notificationSucces: 'notification/success'
    }),
    changeImageFilters(type, value) {
      this.image.filters[type] = value
      this.reDrawImg()
    },
    formatBaseUrl(url) {
      const lastChar = url.substr(-1)
      return lastChar === '/' ? url.slice(0, -1) : url
    },
    init() {
      return getImage(this.imageId)
        .then(res => {
          const filters = this.image?.filters || { ...defaultImageFilters }
          this.image = { ...res.data, filters }
          this.comment = res.data.comment
        })
        .catch(e => console.log(e))
    },
    commentDialogCloseHandler() {
      this.isShowCommentModal = false
    },
    submitCommentHandler(val) {
      this.comment = val
      putFavoritesRaceImages({ image_id: this.imageId, comment: this.comment })
      this.commentDialogCloseHandler()
    },
    openCommentDialog() {
      this.isShowCommentModal = true
    },
    feedback() {
      return postFeedback([this.imageId])
        .then(res => {
          if (res.status === 201){
            this.notificationSucces('The issue report was sent. Auto-tags model will be updated after the review')
          } else if (res.status === 204) {
            this.notificationSucces('The issue report was deleted.')
          }
          return res
        })
    },
    backToRace() {
      if (this.paramImageId) {
        this.close()
        return
      }
      let route = this.routeFrom && this.routeFrom.name === 'race' ? this.routeFrom : { name: 'race', params: { raceId: this.image.race_id }}
      this.$router.push(route)
    },
    changeSelectedCar(car) {
      this.selectedCar = car._id === this.selectedCar._id ? {} : car
    },
    undoLine() {
      this.$refs.imgCanvas.undoLine()
    },
    async saveImage(image) {
      let { lines } = image
      postImageLines(this.imageId, { lines })
        .then(() => {
          this.notificationSucces('Drawing was added')
          return this.init()
        })
    },
    copyURL() {
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        const href = this.paramImageId ? `${this.formatBaseUrl(process.env.VUE_APP_BASE_API_PATH)}/image/${this.paramImageId}` : location.href
        navigator.clipboard.writeText(href)
        .then(() => {
          this.notificationSucces('URL link was copied')
        })
        .catch(err => {
          console.log('Something went wrong', err)
        })
      }
    },
    goImage(go) {
      const {race_id, _id} = this.image
      if (this.paramImageId) {
        this.$emit('changeImage', go)
        return
      }
      return getImagePreviousNext( race_id, _id, {go})
        .then(res => {
          if (res.data._id) {
            this.$router.push({ name: 'image', params: { imageId: res.data._id } })
          }
        })
    },
    reDrawImg() {
      this.$refs?.imgCanvas?.reDrawImg()
    },
    changeOption(option, value) {
      this.options[option] = value
    },
    close(){
      this.$emit('close')
    }
  },
  watch: {
    imageId() {
      this.image = null
      this.init()
    },
    paramImageId() {
      if(this.image) {
        this.init()
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeRouteEnter(_, from, next) {
    next(vm => {
      vm.routeFrom = from
    })
  }
}
</script>


<style lang="scss" scoped>
.image-wrap {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.image-header {
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 52px;
  padding: 2px 16px;
  background-color: var(--v-blue-lighten-4);
  box-shadow: inset 0px -1px 0px var(--v-blue-lighten-2);
}

.image-header-left {
  display: flex;
  gap: 16px;
  align-items: center;
  color: var(--v-primary-base);
}

.back-btn {
  border: 1px solid var(--v-blue-lighten-1);
  background-color: white;
}

.image-content {
  display: flex;
  flex: 1;
}

.image-tags {
  display: flex;
  gap: 4px;
  padding: 0;
  font-size: 14px;
  line-height: 24px;
}

.image-tags-item {
  padding: 4px 12px;
  background: var(--v-blue-lighten-3);
  border-radius: 6px;
}

.divider {
  height: 100%;
  max-height: 40px;
  width: 1px;
  background: var(--v-blue-lighten-2);
}

::v-deep {
  .v-btn--icon {
    width: 32px;
    height: 32px;
  }

  .image-navigation {
    display: flex;
    gap: 4px;

    .v-btn {
      background-color: var(--v-blue-lighten-3);

      path {
        fill: var(--v-blue-lighten-1);
      }
    }
  }

  .switch-boxes {
    margin-top: 0;

    .v-input__slot {
      flex-direction: column;
    }

    .v-input--selection-controls__input {
      margin-right: 0;
      height: 16px;
      width: 32px;
    }

    .v-input--switch__track {
      height: inherit!important;
      width: inherit!important;
      left: 0!important;
      top: 0!important;
    }

    .v-input--switch__thumb {
      width: 12px;
      height: 12px;
      translate: 2px 4px;

      &.primary--text {
        translate: -2px 4px;
      }
    }

    label {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      margin-top: 6px;
    }
  }
}
</style>
